import { Component, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { addIcons } from 'ionicons';
import { informationCircleOutline, checkmarkCircleOutline, warningOutline, alertCircleOutline } from 'ionicons/icons';
import { NetworkService } from './core/services/network.service';
import { NativeBluetoothService } from './core/services/bluetooth/native-bluetooth.service';
import { App } from '@capacitor/app';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { Capacitor } from '@capacitor/core';

addIcons({ informationCircleOutline, checkmarkCircleOutline, warningOutline, alertCircleOutline });

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, IonApp, IonRouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnDestroy {
  constructor(
    private networkService: NetworkService,
    private bluetoothService: NativeBluetoothService
  ) {
    App.addListener('appStateChange', async ({ isActive }) => {
      console.log('App activa:', isActive);

      if (!isActive) {
        if (Capacitor.getPlatform() === 'ios') {
          console.log('iOS en background → desconectando BLE');
          await this.bluetoothService.disconnectDevice();
        }
        return;
      }
      console.log('App en foreground');
    });
  }

  ngOnDestroy() {
    this.networkService.cleanup();
  }
}
